"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.moneraMobileTheme = exports.moneraMobileTypography = void 0;
const spacing_1 = require("../styles/rio/spacing");
const typography_1 = require("../styles/rio/typography");
const monera_1 = require("./monera");
exports.moneraMobileTypography = {
    button: Object.assign(Object.assign({}, typography_1.commonFontAttributes), { fontSize: '1.6rem', lineHeight: '1.35', padding: '1.2rem 1.6rem 1.2rem 1.6rem', width: '100%' })
};
exports.moneraMobileTheme = Object.assign(Object.assign({}, monera_1.moneraTheme), { spacings: spacing_1.rioMobileSpacings, typography: Object.assign(Object.assign({}, typography_1.rioMobileFonts), exports.moneraMobileTypography) });
